export default "__VITE_ASSET__CCZGEwER__"